interface Route {
  path: string;
}

export const Routes: { [key: string]: Route } = {
  home: { path: '/' },
  dashboard: { path: '/dashboard' },
  users: { path: '/users' },
  login: { path: '/login' },
  profile: { path: '/profile' },
  editProfile: { path: '/profile/edit' },
  editUserProfile: { path: '/profile/:id/edit' },
  profileUserMergeRequest: { path: '/profile/user-merge-request' },
  authCallback: { path: '/auth-callback' },
  myOrganisation: { path: '/' },
  restaurants: { path: '/restaurants' },
  lmsCurriculums: { path: '/lms/curriculums' },
  wttpBase: { path: '/wttp' },
  wttpQuestions: { path: '/wttp/questions' },
  wttpTemplates: { path: '/wttp/templates' },
  wttpQuestion: { path: '/wttp/questions/:id' },
  wttpQuestionnaires: { path: '/wttp/questionnaires' },
  wttpQuestionnaireAnswer: { path: '/wttp/questionnaire/:id/answer' },
  wttpQuestionnaireResponses: { path: '/wttp/surveys' },
  wttpConfiguration: { path: '/wttp/configuration' },
  issueTickets: { path: '/issues' },
  notificationList: { path: '/notifications' },
  notificationPreferences: { path: '/notification/preferences' },
  mostBase: { path: '/most' },
  tools: { path: '/tools' },
  // admin routes
  admin: { path: '/admin' },
  permissions: { path: '/admin/permissions' },
  roles: { path: '/admin/roles' },
  userGroups: { path: '/admin/user-groups' },
  loginRules: { path: '/admin/login-rules' },
  loginRuleCreate: { path: '/admin/login-rules/create' },
  lmsCurriculumsAdmin: { path: '/admin/curriculums' },
  lmsCurriculumCreate: { path: `/admin/curriculums/create` },
  lmsCertificates: { path: '/admin/certificates' },
  userMergeRequests: { path: '/admin/user-merge-requests' },
  userMergeRequestsCreate: { path: '/admin/user-merge-requests/create' },
  fieldOfficeCountOtpReport: { path: '/reports/field-office/count-otp' },
  adminResources: { path: '/admin/resources' },
  adminResourcesCreate: { path: '/admin/resources/create' },
  adminResourcesUpdate: { path: '/admin/resources/:id/edit' },
  resources: { path: '/resources' },
  search: { path: '/search' },
  reports: { path: '/reports' },
};
